import { useAsyncRetry } from 'react-use'
import { integrationsApi } from '@/api'
import type { IntegrationItem } from '@/api/integrations/integrations.types'
import { filterWazzupCrmIntegrations } from '@pages/Admin/CRMSettings/tabs/GeneralPage/components/WazzupCrmSettings/lib/wazzupCrmIntegration.helpers'

export type UseWazzupCrmAccountsResult = {
  accounts: IntegrationItem[]
  isLoading: boolean
  error: string | null
  retry: () => void
}

/** GET /integrations?provider=wazzup&usage=crm → connected accounts. */
export const useWazzupCrmAccounts = (
  enabled = true,
): UseWazzupCrmAccountsResult => {
  const state = useAsyncRetry(async () => {
    if (!enabled) {
      return [] as IntegrationItem[]
    }

    const res = await integrationsApi.getAll({
      provider: 'wazzup',
      usage: 'crm',
    })
    const raw = res?.data?.data ?? res?.data
    const list = filterWazzupCrmIntegrations(Array.isArray(raw) ? raw : [])

    return list.filter((item) => item.status === 'connected')
  }, [enabled])

  return {
    accounts: state.value ?? [],
    isLoading: Boolean(state.loading),
    error: state.error
      ? 'Не удалось загрузить аккаунты Wazzup'
      : null,
    retry: () => {
      void state.retry()
    },
  }
}
